//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	props: ['socialMidiaList', 'availWidthSet', 'post'],
	data() {
		return {
			artigo: {},
		}
	},
	watch: {
		$route() {
			this.artigo = this.post
		},
	},
	created() {
		this.artigo = this.post
	},
}
